import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LabelsProviderPipe } from 'src/app/pipes/labels-provider/labels-provider.pipe';
import { LucideIconsModule } from 'src/app/shared/icons/lucide-icons.module';
import { RedTeamSessionStatus } from 'src/app/models/api/red-team/red-team.enums';

interface StatusConfig {
  readonly label: string;
  readonly cssClass: string;
  readonly icon: string;
}

const STATUS_MAP: Record<RedTeamSessionStatus, StatusConfig> = {
  [RedTeamSessionStatus.Pending]: {
    label: 'attackSimulationsPage.statuses.pending',
    cssClass: 'pending',
    icon: 'clock-fading',
  },
  [RedTeamSessionStatus.Executing]: {
    label: 'attackSimulationsPage.statuses.executing',
    cssClass: 'executing',
    icon: 'clock-fading',
  },
  [RedTeamSessionStatus.FinishedSuccess]: {
    label: 'attackSimulationsPage.statuses.finishedSuccess',
    cssClass: 'success',
    icon: 'circle-check-big',
  },
  [RedTeamSessionStatus.FinishedFail]: {
    label: 'attackSimulationsPage.statuses.finishedFail',
    cssClass: 'failed',
    icon: 'circle-x',
  },
};

const DEFAULT_CONFIG: StatusConfig = {
  label: 'attackSimulationsPage.statuses.pending',
  cssClass: 'pending',
  icon: 'loader-circle',
};

@Component({
  selector: 'app-simulation-status-badge',
  standalone: true,
  imports: [CommonModule, LabelsProviderPipe, LucideIconsModule],
  templateUrl: './simulation-status-badge.component.html',
  styleUrl: './simulation-status-badge.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SimulationStatusBadgeComponent {
  readonly status = input.required<RedTeamSessionStatus>();

  readonly config = computed<StatusConfig>(() => STATUS_MAP[this.status()] ?? DEFAULT_CONFIG);
}
